// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3oUAO","insightsList":"newBusinessInsightsMenu_insightsList__1MZq0","active":"newBusinessInsightsMenu_active__11ciE"};